import axios from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
  timeout: 1200000, // 20 minutes - for heavy processing like AI clip generation and large video uploads
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Get token from localStorage directly to avoid store initialization issues
    const token = localStorage.getItem('clipflow_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth data
      localStorage.removeItem('clipflow_token')
      localStorage.removeItem('clipflow_user')

      // Only redirect if not already on login page
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    } else if (error.response?.status === 403) {
      // Handle 403 permission errors globally
      // Import the composable dynamically to avoid circular dependencies
      import('@/composables/usePermissionError').then(({ usePermissionError }) => {
        const { showPermissionError } = usePermissionError()
        const message = error.response?.data?.message ||
                       error.response?.data?.error ||
                       'You don\'t have permission to access this resource.'
        showPermissionError(message)
      })
    }
    return Promise.reject(error)
  },
)

export default api
